import Plan from './components/Plan';
export default Plan;